import React from 'react';
import CareSourceReorganizationSheet from './CareSourceReorganizationSheet';
import { buildOrganizedCaptureDraft } from './reorganizationDraft';

const useCareSourceReorganization = ({
  enabled,
  sourceNoteId,
  scenes = [],
  useOriginalSource = false,
} = {}) => {
  const [open, setOpen] = React.useState(false);
  const [hasOpened, setHasOpened] = React.useState(false);
  const organizedDraft = React.useMemo(() => buildOrganizedCaptureDraft(scenes), [scenes]);
  const action = enabled ? {
    label: 'Reorganize with Lifelog',
    description: 'Correct what Lifelog understood without changing the original capture.',
    onClick: () => {
      setHasOpened(true);
      setOpen(true);
    },
  } : null;
  const sheet = hasOpened ? (
    <CareSourceReorganizationSheet
      open={open}
      onClose={() => setOpen(false)}
      sourceNoteId={sourceNoteId}
      initialOrganizedDraft={useOriginalSource ? 'Reorganize the original forwarded email.' : organizedDraft}
      useOriginalSource={useOriginalSource}
    />
  ) : null;

  return { action, sheet };
};

export default useCareSourceReorganization;
